import React from "react";

const CalciteModal = ({ onBeforeClose, onBeforeOpen, onClose, onOpen, ...props }) => {
  const modalRef = React.useRef(null);

  // on component mount
  React.useEffect(() => {
    const modal = modalRef.current;
    const onBeforeCloseHandler = onBeforeClose;
    const onBeforeOpenHandler = onBeforeOpen;
    const onCloseHandler = onClose;
    const onOpenHandler = onOpen;

    if (onBeforeCloseHandler) modal.addEventListener("calciteModalBeforeClose", onBeforeCloseHandler);
    if (onBeforeOpenHandler) modal.addEventListener("calciteModalBeforeOpen", onBeforeOpenHandler);
    if (onCloseHandler) modal.addEventListener("calciteModalClose", onCloseHandler);
    if (onOpenHandler) modal.addEventListener("calciteModalOpen", onOpenHandler);

    // on component unmount
    return () => {
      if (onBeforeCloseHandler) modal.removeEventListener("calciteModalBeforeClose", onBeforeCloseHandler);
      if (onBeforeOpenHandler) modal.removeEventListener("calciteModalBeforeOpen", onBeforeOpenHandler);
      if (onCloseHandler) modal.removeEventListener("calciteModalClose", onCloseHandler);
      if (onOpenHandler) modal.removeEventListener("calciteModalOpen", onOpenHandler);
    };
  }, [modalRef, onBeforeClose, onBeforeOpen, onClose, onOpen]);

  return (
    <calcite-modal
      ref={modalRef}
      class={props.className}
      close-button-disabled={props.closeButtonDisabled || undefined}
      docked={props.docked || undefined}
      escape-disabled={props.escapeDisabled || undefined}
      focus-trap-disabled={props.focusTrapDisabled || undefined}
      fullscreen={props.fullscreen || undefined}
      kind={props.kind || undefined}
      message-overrides={props.messageOverrides || undefined}
      open={props.open || undefined}
      outside-close-disabled={props.outsideCloseDisabled || undefined}
      scale={props.scale || undefined}
      width={props.width || undefined}
    >
      {props.children}
    </calcite-modal>
  );
};

export default CalciteModal;
